// extracted by mini-css-extract-plugin
module.exports = {"column":"hideColumnsMenu_column__rnjoS"};